import React from "react";
import classnames from "classnames";
import ReactSwitch from "react-switch";
import { EyeIcon, TrashIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import TimePastSvgIcon from "@components/Common/SvgIcons/TimePastSvgIcon";

import { store as logo } from "../../../../components/VerticalLayout/store";
import store, {
    setIsHistoryShopsModalOpened,
    setSelectedLogo,
    setIsLoading,
    setActiveLogo,
} from "../store";
import ErrorToast from "@components/Common/ErrorTost";
import {
    setActivationDeactivationMessageModalOpened,
    setMessage,
    setYesFunction,
} from "@components/Common/ConfirmationActivationDeactivationMessageModal/store";
import {
    handleActiveLogo,
    handleArchiveLogo,
    handleStateChange,
    isSaleSupportArchived,
} from "./hooks";
import { useFetchGlobal } from "../../../../api/hooks";

export function CustomIcons({ selectedRowData, isLogoArchived }: any) {
    const { t } = useTranslation();
    const {
        numberActiveMultiShop,
        numberArchiveMultiShop,
        isHistoryShopsModalOpened,
        logoData,
        modify,
        isLoading,
        shopsLogoData,
    } = useSnapshot(store);
    const { franchiseID, userID, operatorID } = useSnapshot(logo);
    const { fetchGlobal } = useFetchGlobal();
    const elements = shopsLogoData.find(
        (el: any) => el.shopId === selectedRowData.selectedRow.shopId
    ).subRows;
    const [choiceState] = React.useState<boolean>(
        selectedRowData.selectedRow?.isActive
    );
    const [isClicked, setIsClicked] = React.useState<boolean>(false);
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const uuidUser = localStorage.getItem("uuidUser");

    function ArchivedLogo() {
        let idsAssociated: any[] = [];
        if (logoData !== undefined) {
            logoData.forEach((element: any) => {
                idsAssociated.push(element.Id);
            });
        }
        idsAssociated = [...new Set(idsAssociated)];
        return idsAssociated;
    }
    let dataArchive = ArchivedLogo();

    return (
        <React.Fragment>
            {selectedRowData.selectedRow?.subRows === undefined ? (
                <div className="d-flex justify-content-around">
                    {modify === true ? (
                        <>
                            <Tooltip
                                title={
                                    isLogoArchived
                                        ? ""
                                        : choiceState === false
                                        ? t("Activate")
                                        : t("Unactivate")
                                }
                            >
                                <div>
                                    <ReactSwitch
                                        uncheckedIcon={false}
                                        checkedIcon={false}
                                        handleDiameter={26}
                                        offColor="#f7b4b8"
                                        offHandleColor="#E30613"
                                        checked={choiceState}
                                        onChange={(e: boolean) => {
                                            setMessage(
                                                choiceState
                                                    ? t(
                                                          "Caution, the Logo may be used by other modules.\n Would you like to confirm the deactivation of the selected Logo?"
                                                      )
                                                    : t(
                                                          "Would you like to confirm the activation of the selected Logo?"
                                                      )
                                            );
                                            setYesFunction(() => {
                                                elements.forEach(
                                                    (logo: any) => {
                                                        if (
                                                            logo.Id ===
                                                            selectedRowData
                                                                .selectedRow.Id
                                                        ) {
                                                            setActiveLogo({
                                                                id: logo.Id,
                                                                state: !choiceState,
                                                            });
                                                        } else if (
                                                            logo.Id !==
                                                                selectedRowData
                                                                    .selectedRow
                                                                    .Id &&
                                                            choiceState ===
                                                                false
                                                        ) {
                                                            setActiveLogo({
                                                                id: logo.Id,
                                                                state: false,
                                                            });
                                                        }
                                                    }
                                                );
                                                handleStateChange(
                                                    e,
                                                    shopsLogoData,
                                                    selectedRowData,
                                                    userID,
                                                    franchiseID,
                                                    operatorID,
                                                    uuidUser,
                                                    choiceState,
                                                    fetchGlobal
                                                );
                                            });

                                            setActivationDeactivationMessageModalOpened(
                                                true
                                            );
                                        }}
                                        onColor="#c2eddd"
                                        onHandleColor="#34C38F"
                                        width={50}
                                        height={20}
                                        className={`${classnames(
                                            "pointer__clz ml-2 cmn_icn_BTenableDisable",
                                            {
                                                "not-allowed-icon__clz":
                                                    isLogoArchived || isLoading,
                                            }
                                        )}`}
                                    />
                                </div>
                            </Tooltip>

                            {!isLogoArchived ? (
                                <Tooltip title={t("Archive")}>
                                    <div>
                                        <TrashIcon
                                            onClick={() => {
                                                setIsLoading(true);
                                                handleArchiveLogo(
                                                    selectedRowData?.selectedRow,
                                                    setIsClicked,
                                                    userID,
                                                    franchiseID,
                                                    operatorID,
                                                    uuidUser,
                                                    numberActiveMultiShop,
                                                    numberArchiveMultiShop,
                                                    fetchGlobal
                                                );
                                            }}
                                            height={25}
                                            width={25}
                                            fill="red"
                                            style={{ cursor: "pointer" }}
                                            className={`${classnames(
                                                "pointer__clz ml-2 cmn_icn_BTarchived",
                                                {
                                                    "not-allowed-icon__clz":
                                                        isLoading || isClicked,
                                                }
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            ) : (
                                <Tooltip
                                    title={
                                        dataArchive.includes(
                                            selectedRowData.selectedRow.Id
                                        )
                                            ? ""
                                            : t("Unarchive")
                                    }
                                >
                                    <div>
                                        <EyeIcon
                                            height={25}
                                            width={25}
                                            style={{ cursor: "pointer" }}
                                            onClick={async () => {
                                                setIsLoading(true);
                                                let isArchived = await isSaleSupportArchived(
                                                    selectedRowData,
                                                    userID,
                                                    franchiseID,
                                                    uuidUser,
                                                    i18nextLng,
                                                    fetchGlobal
                                                );

                                                if (isArchived === true) {
                                                    ErrorToast(
                                                        `${t(
                                                            "Please note that  the unarchiving process could not be successfully completed. Please check the settings of the store(s) data."
                                                        )!}`
                                                    );
                                                    setIsLoading(false);
                                                } else {
                                                    handleActiveLogo(
                                                        selectedRowData,
                                                        numberActiveMultiShop,
                                                        numberArchiveMultiShop,
                                                        userID,
                                                        franchiseID,
                                                        operatorID,
                                                        uuidUser,
                                                        setIsClicked,
                                                        fetchGlobal
                                                    );
                                                }
                                            }}
                                            className={`${classnames(
                                                "pointer__clz ml-2 cmn_icn_BTunarchive",
                                                {
                                                    "not-allowed-icon__clz":
                                                        isLoading ||
                                                        dataArchive.includes(
                                                            selectedRowData
                                                                .selectedRow.Id
                                                        ),
                                                }
                                            )}`}
                                        />
                                    </div>
                                </Tooltip>
                            )}
                        </>
                    ) : null}
                    <Tooltip title={t("Consult history")}>
                        <div>
                            <TimePastSvgIcon
                                className={classnames(
                                    "pointer__clz ml-2 cmn_icn_BThistory",
                                    {
                                        "not-allowed-icon__clz": isLoading,
                                    }
                                )}
                                onClick={() => {
                                    setIsHistoryShopsModalOpened(
                                        !isHistoryShopsModalOpened
                                    );

                                    setSelectedLogo([
                                        {
                                            [selectedRowData.selectedRow
                                                .shopId]:
                                                selectedRowData.selectedRow.Id,
                                        },
                                    ]);
                                }}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
        </React.Fragment>
    );
}
